import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyFormatterPipe } from './pipes/key-formatter.pipe';


@NgModule({
  declarations: [
    KeyFormatterPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [CommonModule, KeyFormatterPipe]
})
export class SharedModule { }
